import { Stack } from '@mui/material';
import React from 'react';
import { Tab } from './TabbedSection';
import TabRow from './TabRow';
import './TabSelector.scss';

interface TabSelectorProps {
  selectedTab: Tab;
  selectTab: (tab: Tab) => any;
}

function TabSelector({ selectedTab, selectTab }: TabSelectorProps) {
  return (
    <div className="tab-selector">
      <Stack>
        {Object.values(Tab)
          .filter((tab) => typeof tab === 'number')
          .map((tab) => {
            return (
              <TabRow
                key={tab}
                isSelected={selectedTab === tab}
                // @ts-ignore
                tab={tab}
                selectTab={selectTab}
              />
            );
          })}
      </Stack>
    </div>
  );
}

export default TabSelector;
